const Footer = () => {
  return (
    <footer className="sticky-footer bg-white">
      <div className="container my-auto">
        <div className="copyright text-center my-auto">
          <span>Copyright &copy; Primera 2026</span>
        </div>
      </div>
    </footer>
  );
};
export default Footer;
